export const getSalesOrderDisplayJobNumber = (row) => {
  if (!row) return null

  const estDoc = row?.est_doc_number
  if (estDoc != null && String(estDoc).trim() !== '') {
    return String(estDoc).trim()
  }

  const docNumber = row?.doc_number
  const rowId = row?.id
  if (
    docNumber != null &&
    String(docNumber).trim() !== '' &&
    String(docNumber) !== String(rowId)
  ) {
    return String(docNumber).trim()
  }

  return null
}

export const getGroupedSalesOrderJobNumbers = (parentRow, childRows = []) => {
  const numbers = []
  const parentNumber = getSalesOrderDisplayJobNumber(parentRow)
  if (parentNumber) numbers.push(parentNumber)

  ;(childRows || []).forEach((child) => {
    const childNumber = getSalesOrderDisplayJobNumber(child)
    if (childNumber && !numbers.includes(childNumber)) {
      numbers.push(childNumber)
    }
  })

  return numbers
}

export const getGroupedSalesOrderJobNumbersText = (parentRow, childRows = []) =>
  getGroupedSalesOrderJobNumbers(parentRow, childRows).join(', ')

const isDedicatedGroupedParent = (row) => Number(row?.is_grouped_request || 0) === 1

export const isPublishedInvoiceNumber = (row) => {
  if (!row) return false

  const docNumber = row?.doc_number
  if (docNumber == null || String(docNumber).trim() === '') return false
  if (String(docNumber) === String(row?.id)) return false
  if (row?.invoice_qb_id) return true

  const estDocNumber = row?.est_doc_number
  if (
    estDocNumber != null
    && String(estDocNumber).trim() !== ''
    && String(docNumber) === String(estDocNumber)
  ) {
    return false
  }

  return true
}

export const getGroupedInvoiceDisplayNumbers = (parentRow, childRows = []) => {
  const isDedicatedParent = isDedicatedGroupedParent(parentRow)
  const parentApproved = Number(parentRow?.installation_acceptance || 0) === 1

  if (isDedicatedParent && parentApproved) {
    if (isPublishedInvoiceNumber(parentRow)) {
      return [String(parentRow.doc_number).trim()]
    }
    return []
  }

  const numbers = []
  const addInvoiceNumber = (row) => {
    if (!isPublishedInvoiceNumber(row)) return
    const value = String(row.doc_number).trim()
    if (!numbers.includes(value)) numbers.push(value)
  }

  addInvoiceNumber(parentRow)
  ;(childRows || []).forEach(addInvoiceNumber)
  return numbers
}

export const getGroupedInvoiceDisplayNumbersText = (parentRow, childRows = []) =>
  getGroupedInvoiceDisplayNumbers(parentRow, childRows).join(', ')
